module.exports = __webpack_public_path__ + "aa325406a50ca95cceb501437beb05c8.png";